import { render, staticRenderFns } from "./mandatory-comments.vue?vue&type=template&id=a8662b9a&"
import script from "./mandatory-comments.vue?vue&type=script&lang=js&"
export * from "./mandatory-comments.vue?vue&type=script&lang=js&"
import style0 from "./mandatory-comments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports